import type { IDeprecatedService } from '~/types/deprecation'

import {
  getCatalystBusinessReportUrl,
  getCatalystCohortedAnalyticsUrl,
  getCatalystDynamicScreenUrl,
} from '~/utils/catalyst'

/**
 * Services moved out of this intranet: their pages display a banner linking to the new location
 */
export const DEPRECATED_SERVICES: IDeprecatedService[] = [
  {
    getRedirectUrl: getCatalystCohortedAnalyticsUrl,
    name: 'Cohorted Analytics',
    pathnamePrefixes: ['/analytics/ca', '/compare-cohorts'],
    redirectLabel: 'Catalyst',
    removalDate: '2026-10-28',
  },
  {
    getRedirectUrl: getCatalystBusinessReportUrl,
    name: 'Business Report',
    // NOTE: the graph builder pages (overview, sandbox) have no Catalyst counterpart
    pathnamePrefixes: ['/analytics/business-report/legacy'],
    redirectLabel: 'Catalyst',
    removalDate: '2026-10-28',
  },
  {
    getRedirectUrl: getCatalystDynamicScreenUrl,
    name: 'Dynamic Screen',
    pathnamePrefixes: ['/dynamic-screens'],
    // NOTE: its pages have fixed headers of their own
    popupOnly: true,
    redirectLabel: 'Catalyst',
    removalDate: '2026-10-28',
  },
]
